import tagManager from "./chat/tags";
import posthog, { PostHog } from "posthog-js";
import log from "./log";

function afterPostHogLoaded(posthog: PostHog) {
  const distinctId = posthog.get_distinct_id(); // relevant if .identify() was called
  const sessionId = posthog.get_session_id();
  tagManager.setTags({
    "chat:posthog.distinctId": distinctId,
    "chat:posthog.sessionId": sessionId,
  });
}

export function setupAnalytics() {
  if (!import.meta.env.VITE_POSTHOG_APIKEY) {
    log.debug("botbrains.analytics.init: skipping for 'local' environment");
    return;
  }
  log.debug("botbrains.analytics.init");
  posthog.init(import.meta.env.VITE_POSTHOG_APIKEY, {
    disable_session_recording: true,
    disable_persistence: true,
    person_profiles: "identified_only", // reduces costs by 80%, because we do not process person profiles
    api_host: "https://eu.posthog.com",
    loaded: afterPostHogLoaded,
    // TODO(liamvdv): continue to check whether CSS selector matches all children props scope to `#botbrains-shadow-host`
    // Capture config to reduce event volume
    capture_pageview: true,
    capture_pageleave: true,
    autocapture: {
      // Selector should match complete subtree https://github.com/PostHog/posthog-js/blob/ee272dfda9faf9bdd14bc2b80e7c636849d9197d/src/autocapture-utils.ts#L147
      css_selector_allowlist: ["#botbrains-shadow-host"],
    },
  });
  // NOTE(liamvdv): To ensure events are correctly captured, uncomment the following line.
  // posthog.debug();
}
